import { Chip } from '@mui/material';
import { useTranslate } from 'react-admin';
import {
  calculateDaysUntilDate,
  certificationExpiryChipColor,
  getCertificationExpiryText,
  hasActivePlannedRenewal,
} from '../../../../../utils/certificationsAndItemsExpiry';

type InventoryItemExpiryChipProps = {
  expiryDate: string;
  largestReminderPeriodInDays: number;
  plannedRenewalDate?: string | null;
};

export const InventoryItemExpiryChip = ({
  expiryDate,
  largestReminderPeriodInDays,
  plannedRenewalDate,
}: InventoryItemExpiryChipProps) => {

  const translate = useTranslate();

  const days = calculateDaysUntilDate(expiryDate);
  const isRenewalPlanned = hasActivePlannedRenewal(plannedRenewalDate);

  const label = isRenewalPlanned
    ? translate('resources.certification-categories.text.renewal_planned')
    : getCertificationExpiryText(days, translate);

  const color = isRenewalPlanned
    ? 'primary'
    : certificationExpiryChipColor(days, largestReminderPeriodInDays);

  return (
    <Chip
      label={label}
      color={color}
      variant="outlined"
      size="small"
      sx={{
        maxWidth: 160,
        '& .MuiChip-label': {
          fontSize: '0.65rem',
          lineHeight: 1.2,
          px: 0.75,
          whiteSpace: 'normal',
        },
      }}
    />
  );

};
